export default {
  $dataGrid: state => gridId => {
    try {
      return state.models_dashboardModel[gridId] || {}
    } catch (err) {
      return {}
    }
  },
  $getGrid: state => gridId => {
    try {
      return Object.values(state.models_dashboardModel[gridId]) || []
    } catch (err) {
      return []
    }
  },
  $getLookUpRow: state => (gridId, rowKey) => {
    try {
      return state.models_dashboardModel[gridId][rowKey]
    } catch (err) {
      return null
    }
  },
  dataGrid_select(state) {
    const options = []

    for (let gridId in state.dataGrid_options || {}) {
      options.push({
        text: state.dataGrid_options[gridId].title,
        value: gridId,
      })
    }

    return options
  },
  dataGrid_cellsSelect: state => gridId => {
    try {
      const select = []
      const meta = state.dataGrid_options[gridId].meta

      select.push({ text: 'Row Key', value: 'rowKey' })

      for (let cellKey in meta) {
        select.push({ text: meta[cellKey].displayName, value: cellKey })
      }

      return select
    } catch (err) {
      return []
    }
  },
  dataGrid_title: state => gridId => {
    try {
      return state.dataGrid_options[gridId].title
    } catch (err) {
      return null
    }
  },
}
